export default __webpack_public_path__ + "static/media/login-8.3143f5a1.svg";